import React, { useEffect, useState } from 'react';
import { CheckCircleIcon, XIcon } from 'lucide-react';
// Move purchases data outside component to prevent re-creation on renders
const purchases = [{
  name: 'Carlos',
  location: 'Madrid',
  time: '2 minutos',
  price: '19.997 ARS'
}, {
  name: 'María',
  location: 'Buenos Aires',
  time: '5 minutos',
  price: '19.997 ARS'
}, {
  name: 'Juan',
  location: 'México DF',
  time: '30 segundos',
  price: '19 USD'
}, {
  name: 'Alejandro',
  location: 'Bogotá',
  time: '1 minuto',
  price: '19 USD'
}, {
  name: 'Sofía',
  location: 'Santiago',
  time: '3 minutos',
  price: '19 USD'
}, {
  name: 'Miguel',
  location: 'Lima',
  time: '4 minutos',
  price: '19 USD'
}, {
  name: 'Lucía',
  location: 'Montevideo',
  time: '2 minutos',
  price: '19 USD'
}, {
  name: 'Diego',
  location: 'Barcelona',
  time: '1 minuto',
  price: '19 USD'
}, {
  name: 'Valentina',
  location: 'Medellín',
  time: '30 segundos',
  price: '19 USD'
}, {
  name: 'Javier',
  location: 'Quito',
  time: '5 minutos',
  price: '19 USD'
}, {
  name: 'Isabella',
  location: 'Valencia',
  time: '2 minutos',
  price: '19 USD'
}, {
  name: 'Mateo',
  location: 'Córdoba',
  time: '3 minutos',
  price: '19.997 ARS'
}, {
  name: 'Camila',
  location: 'Sevilla',
  time: '1 minuto',
  price: '19 USD'
}, {
  name: 'Gabriel',
  location: 'Rosario',
  time: '4 minutos',
  price: '19.997 ARS'
}, {
  name: 'Valeria',
  location: 'Guadalajara',
  time: '2 minutos',
  price: '19 USD'
}, {
  name: 'Emilio',
  location: 'Cali',
  time: '30 segundos',
  price: '19 USD'
}, {
  name: 'Daniela',
  location: 'Zaragoza',
  time: '1 minuto',
  price: '19 USD'
}, {
  name: 'Sebastián',
  location: 'Montevideo',
  time: '3 minutos',
  price: '19 USD'
}, {
  name: 'Mariana',
  location: 'La Paz',
  time: '2 minutos',
  price: '19 USD'
}, {
  name: 'Ricardo',
  location: 'San José',
  time: '4 minutos',
  price: '19 USD'
}, {
  name: 'Natalia',
  location: 'Málaga',
  time: '1 minuto',
  price: '19 USD'
}, {
  name: 'Felipe',
  location: 'Mendoza',
  time: '3 minutos',
  price: '19.997 ARS'
}, {
  name: 'Carolina',
  location: 'Panamá',
  time: '2 minutos',
  price: '19 USD'
}, {
  name: 'Andrés',
  location: 'Asunción',
  time: '30 segundos',
  price: '19 USD'
}, {
  name: 'Paulina',
  location: 'Bilbao',
  time: '1 minuto',
  price: '19 USD'
}, {
  name: 'Roberto',
  location: 'San Salvador',
  time: '4 minutos',
  price: '19 USD'
}, {
  name: 'Fernanda',
  location: 'Granada',
  time: '2 minutos',
  price: '19 USD'
}, {
  name: 'Eduardo',
  location: 'Tucumán',
  time: '3 minutos',
  price: '19.997 ARS'
}, {
  name: 'Gabriela',
  location: 'Cartagena',
  time: '1 minuto',
  price: '19 USD'
}, {
  name: 'Tomás',
  location: 'Managua',
  time: '2 minutos',
  price: '19 USD'
}];
export function RecentPurchaseNotification() {
  const [visible, setVisible] = useState(false);
  const [lastPurchaseIndex, setLastPurchaseIndex] = useState(-1);
  const [currentPurchase, setCurrentPurchase] = useState({
    name: '',
    location: '',
    time: '',
    price: ''
  });
  useEffect(() => {
    // Defer notification system initialization to not block initial page load
    let initialTimeout;
    // Use requestIdleCallback to run this when the browser is idle
    if (window.requestIdleCallback) {
      window.requestIdleCallback(() => {
        initialTimeout = setTimeout(initNotificationSystem, 3000);
      });
    } else {
      // Fallback for browsers that don't support requestIdleCallback
      initialTimeout = setTimeout(initNotificationSystem, 3000);
    }
    function initNotificationSystem() {
      // Function to show a random purchase
      const showRandomPurchase = () => {
        // Generate a random index that's different from the last one
        let randomIndex;
        do {
          randomIndex = Math.floor(Math.random() * purchases.length);
        } while (randomIndex === lastPurchaseIndex && purchases.length > 1);
        // Set current purchase based on random index
        setCurrentPurchase(purchases[randomIndex]);
        setLastPurchaseIndex(randomIndex);
      };
      // Function to handle the show/hide cycle
      const handleNotificationCycle = () => {
        // Show notification
        setVisible(true);
        // Schedule hide after display duration (3 seconds)
        const hideTimeout = setTimeout(() => {
          setVisible(false);
          // Schedule next notification after transition completes
          const nextNotificationTimeout = setTimeout(() => {
            showRandomPurchase();
            handleNotificationCycle();
          }, 1500); // Wait 1.5 second after hiding before showing next
          return () => clearTimeout(nextNotificationTimeout);
        }, 3000); // Show for 3 seconds as requested
        return () => clearTimeout(hideTimeout);
      };
      showRandomPurchase();
      handleNotificationCycle();
    }
    // Clean up on component unmount
    return () => {
      clearTimeout(initialTimeout);
    };
  }, [lastPurchaseIndex]); // Only depend on lastPurchaseIndex
  const handleClose = () => {
    setVisible(false);
  };
  return <div className={`fixed bottom-4 right-4 z-40 max-w-xs w-full bg-white rounded-lg shadow-lg border border-gray-200 overflow-hidden transition-all duration-500 ${visible ? 'notification-slide-in' : 'notification-slide-out opacity-0 pointer-events-none'}`} data-id="element-347">
      <div className="p-4" data-id="element-348">
        <div className="flex items-start" data-id="element-349">
          {/* App Icon */}
          <div className="flex-shrink-0 bg-green-100 rounded-full p-2" data-id="element-350">
            <CheckCircleIcon className="h-6 w-6 text-green-600" data-id="element-351" />
          </div>
          {/* Header */}
          <div className="ml-3 w-0 flex-1 pt-0.5" data-id="element-352">
            <p className="text-sm font-medium text-gray-900" data-id="element-353">
              Kit de Emergencia Anti-Estrés Hace {currentPurchase.time}
            </p>
            {/* Content */}
            <p className="mt-1 text-sm text-gray-500" data-id="element-354">
              Nueva compra completada
            </p>
            <p className="mt-1 text-xs text-gray-700" data-id="element-355">
              {currentPurchase.name} de {currentPurchase.location} compró por{' '}
              {currentPurchase.price}
            </p>
          </div>
          <div className="ml-4 flex-shrink-0 flex" data-id="element-356">
            <button className="bg-white rounded-md inline-flex text-gray-400 hover:text-gray-500 focus:outline-none" onClick={handleClose} data-id="element-357">
              <span className="sr-only" data-id="element-358">Cerrar</span>
              <XIcon className="h-5 w-5" aria-hidden="true" data-id="element-359" />
            </button>
          </div>
        </div>
      </div>
    </div>;
}